import { ReactNode } from 'react';
import { AuthProvider } from './AuthContext';
import { ClienteSubunidadeProvider } from './ClienteSubunidadeContext';

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider = ({ children }: AppProviderProps) => (
  <AuthProvider>
    <ClienteSubunidadeProvider>
      {children}
    </ClienteSubunidadeProvider>
  </AuthProvider>
);
